import MesLogo from '../../images/Mes-D-logo-00b.png';

function Footer() {
    const footerYear = new Date().getFullYear()

    return (
        <footer className="footer p-10 mt-4 bg-white text-white-content footer-center">
            <p>Copyright &copy; {footerYear} All rights reserved</p>
            <div className='bg-slate-200 rounded-lg'>
                <img src={MesLogo} />
            </div>
        </footer>
    )
}

export default Footer